import { memo } from 'react';
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';

import { IncentiveTotalsContainer, IncentiveTotalsRow, IncentiveTotalsColumn } from './Rebates.style';
import { Typography } from '@interstate/components/Typography';
import { Spinner } from '@interstate/components/Spinner';

const typographyVariantLabel = 'body-md';
const typographyVariantValue = 'strong-md';

type IncentiveTotalsViewProps = {
    dealerCashTotal: number;
    incentivesTotal: number;
    isCalculating?: boolean;
};

export const IncentiveTotalsView = memo(function IncentiveTotalsView({
    dealerCashTotal,
    incentivesTotal,
    isCalculating = false
}: IncentiveTotalsViewProps) {
    const renderTotal = (amount: number, testId: string) =>
        isCalculating ? (
            <span data-testid={`${testId}-spinner`}>
                <Spinner size={20} />
            </span>
        ) : (
            <Typography sx={{ wordBreak: 'break-word' }} variant={typographyVariantValue} data-testid={testId}>
                {formatDollarsAndCents(amount)}
            </Typography>
        );

    return (
        <IncentiveTotalsContainer>
            <IncentiveTotalsColumn>
                <IncentiveTotalsRow>
                    <Typography variant={typographyVariantLabel}>Dealer Cash Total</Typography>
                    {renderTotal(dealerCashTotal, 'incentives-dealer-cash-total')}
                </IncentiveTotalsRow>
                <IncentiveTotalsRow>
                    <Typography variant={typographyVariantLabel}>Incentives Total</Typography>
                    {renderTotal(incentivesTotal, 'incentives-total')}
                </IncentiveTotalsRow>
            </IncentiveTotalsColumn>
        </IncentiveTotalsContainer>
    );
});
